import contentfulGql from 'js/lib/contentfulGql';

import { entWebsiteBlockAssemblyFragment } from 'bundles/ent-website/queries/EntWebsiteBlockAssembly';

export const entWebsiteMarketoModuleFragment = contentfulGql`#graphql
  fragment EntWebsiteMarketoModule on EntWebsiteMarketoModule {
    slug
    forms {
      redirectUrl
      formIdEnglish
    }
    assets {
      optionalAssetEnglishLong
    }
  }
`;

export const entWebsiteBlockMarketoModuleQuery = contentfulGql`#graphql
  ${entWebsiteBlockAssemblyFragment}
  ${entWebsiteMarketoModuleFragment}
  query entWebsiteBlockMarketoModule($id: String!, $preview: Boolean, $locale: String!) {
    entWebsiteBlockAssembly(id: $id, preview: $preview, locale: $locale) {
      ...EntWebsiteBlockAssembly
      reference {
        __typename
        ...EntWebsiteMarketoModule
      }
    }
  }
`;
